const convertDate = (date?: number | string): string => {
  if (!date || isNaN(Number(date)) || Number(date) === 0) {
    return "";
  }
  return new Date(Number(date) * 1000).toISOString().split("T")[0];
};

const convertDateIso = (date?: string): string => {
  if (!date) {
    return "";
  }
  const d = new Date(date);
  if (isNaN(d.getTime())) {
    return "";
  }
  return d.toISOString().split("T")[0];
};

const convertDateBrComHora = (date?: number | string) => {
  if (!date || isNaN(Number(date)) || Number(date) === 0) {
    return "";
  }
  const d = new Date(Number(date) * 1000);
  if (isNaN(d.getTime())) {
    return "";
  }
  return d.toLocaleString("en-GB");
};

const convertDateBr = (date?: number | string) => {
  if (!date || isNaN(Number(date)) || Number(date) === 0) {
    return "";
  }

  const myDate = new Date(Number(date) * 1000);
  if (isNaN(myDate.getTime())) {
    return "";
  }
  return (
    myDate.getUTCDate() +
    "/" +
    (myDate.getUTCMonth() + 1 + "").padStart(2, "0") +
    "/" +
    myDate.getUTCFullYear()
  );
};

const convertDateUs = (date?: number | string) => {
  if (!date || isNaN(Number(date)) || Number(date) === 0) {
    return "";
  }
  const d = new Date(Number(date) * 1000);
  if (isNaN(d.getTime())) {
    return "";
  }
  return d.toLocaleDateString();
};

const convertDateBrToIso = (date?: string): string => {
  if (!date) {
    return "";
  }
  const match = String(date).match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (match) {
    const [, day, month, year] = match;
    return `${year}-${month}-${day}`;
  }
  const d = new Date(date);
  if (isNaN(d.getTime())) {
    return "";
  }
  return d.toISOString().split("T")[0];
};

const convertStringDateToBr = (date?: string) => {
  if (!date) {
    return "";
  }
  const dateClean = String(date).split("T")[0].split(" ")[0];
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateClean)) {
    const [year, month, day] = dateClean.split("-");
    return `${day}/${month}/${year}`;
  }
  const d = new Date(date);
  if (isNaN(d.getTime())) {
    return "";
  }
  return d.toLocaleDateString();
};

const getFullYear = () => {
  const dataAtual = new Date();
  return dataAtual.getFullYear();
};

const tomorrowDate = () => {
  const tomorrow = new Date();
  const timestamp = tomorrow.setDate(tomorrow.getDate() + 1);
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  return year + "-" + month + "-" + day;
};
export {
  convertDate,
  convertDateIso,
  convertDateBrToIso,
  convertDateBr,
  convertDateUs,
  convertStringDateToBr,
  getFullYear,
  tomorrowDate,
  convertDateBrComHora,
};
